/**
 * Handle DOM ready state (and beforeunload) on highest priority.
 * This should run first.
 */
import emitter from '../../utils/emitter';

export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  'use strict';

  let initialized = false;
  
  return () => {
    if (initialized) {
      // do not runs more then once
      return;
    }

    // jQuery DOM Ready event
    $(() => {
      emitter.fire('global-ready');

      // add -ready class
      window.requestAnimationFrame(() => {
        $('html').addClass('-ready');
      });
    });

    // before unload
    window.addEventListener('beforeunload', function(event) {
      $('html').removeClass('-ready');
      emitter.fire('global-unloading');
    });
  };

})(jQuery, window);